module.exports = __webpack_public_path__ + "img/image5.cbffef03.png";